import { CreditCardIcon, FileTextIcon, DownloadIcon, type LucideIcon } from 'lucide-react';

export interface PricingRow {
  content: string;
  value: string;
}

export const pricingRows: PricingRow[] = [
  { content: 'Colección Completa (6 Tomos)', value: '59,90€' },
  { content: 'Los 5 Bonos Estratégicos', value: '59,50€' },
  { content: 'Acceso de por vida', value: '—' }
];

export interface PricingTrustItem {
  icon: LucideIcon;
  label: string;
}

export const pricingTrustItems: PricingTrustItem[] = [
  { icon: CreditCardIcon, label: 'Pago único' },
  { icon: FileTextIcon, label: 'Formato digital' },
  { icon: DownloadIcon, label: 'Acceso mediante enlace de descarga' }
];
